import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import Button, { ButtonKind } from 'bloko/blocks/button';
import Column from 'bloko/blocks/column';
import Gap from 'bloko/blocks/gap';
import Modal, { ModalContent, ModalFooter, ModalHeader, ModalTitle } from 'bloko/blocks/modal';
import Text from 'bloko/blocks/text';
import Textarea from 'bloko/blocks/textarea';

import useTrls from 'hooks/translation/useTrls';

import fetchTranslation from 'components/Admin/Translations/TranslationEditModal/fetchTranslation';
import saveTranslation from 'components/Admin/Translations/TranslationEditModal/saveTranslation';

import { useDispatch } from 'store/utils';

const TranslationEditModal = ({ isVisible, setHidden, editableKey, resetEditableKey }) => {
    const [translation, setTranslation] = useState({});
    const [newTranslation, setNewTranslation] = useState('');
    const dispatch = useDispatch();
    const trl = useTrls();

    useEffect(() => {
        if (editableKey) {
            fetchTranslation(editableKey, setTranslation);
        }
    }, [editableKey]);

    const closeModal = () => {
        setHidden();
        setTranslation({});
        setNewTranslation('');
        resetEditableKey();
    };

    return (
        <Modal visible={isVisible && !!translation.key} onClose={closeModal}>
            <ModalHeader>
                <ModalTitle>{trl('admin.Translations.ModalEditing.title')}</ModalTitle>
            </ModalHeader>
            <ModalContent>
                <Column xs="4" s="6" m="8" l="10" container>
                    <Text strong>{trl('admin.Translations.ModalEditing.oldValue')}</Text>
                    <p>{translation.value}</p>
                    <Gap top>
                        <Text strong>{trl('admin.Translations.ModalEditing.newValue')}</Text>
                        <Textarea
                            placeholder={trl('admin.Translations.ModalEditing.placeholder')}
                            onChange={(event) => setNewTranslation(event.target.value)}
                            value={newTranslation}
                        />
                    </Gap>
                </Column>
            </ModalContent>
            <ModalFooter>
                <Button
                    onClick={() => {
                        dispatch(saveTranslation(editableKey, newTranslation));
                        closeModal();
                    }}
                    kind={ButtonKind.Primary}
                >
                    {trl('admin.Translations.ModalEditing.save')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

TranslationEditModal.propTypes = {
    isVisible: PropTypes.bool,
    setHidden: PropTypes.func,
    editableKey: PropTypes.string,
    resetEditableKey: PropTypes.func,
};

export default TranslationEditModal;
